import { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { type MessageGroup as MessageGroupModel } from '@/features/messaging/ConversationViewModel'
import { type MessageViewModel } from '@/features/messaging/MessageViewModel'
import {
  BubbleLayoutContext,
  MessageGroup,
  MessageGroupMessage,
} from '@/features/messaging/components/ConversationView/Messages/List/MessageGroup'
import {
  messageEditProps,
  messageSender,
} from '@/features/messaging/components/ConversationView/Messages/List/message-bindings'
import { MessageContentContainer } from '@/features/messaging/components/ConversationView/Messages/List/MessageContentContainer'
import { match } from '@/utils/pattern-match-util'
import { BubbleMessageGroupContainer } from '@/features/messaging/components/ConversationView/Messages/List/BubbleMessageGroup/BubbleMessageGroupContainer'

export interface MessageGroupContainerProps {
  group: MessageGroupModel
}

export const MessageGroupContainer = observer(function MessageGroupContainer({
  group,
}: MessageGroupContainerProps) {
  const bubbles = useContext(BubbleLayoutContext)
  if (bubbles) {
    return <BubbleMessageGroupContainer group={group} />
  }

  return (
    <MessageGroup showDateLine={group.showDateLine} timestamp={group.timestamp}>
      {group.messages.map((messageVm, i) => (
        <MessageGroupMessageContainer
          group={group}
          key={messageVm.message.id}
          messageVm={messageVm}
          first={i === 0}
        />
      ))}
    </MessageGroup>
  )
})

interface MessageGroupMessageContainerProps {
  messageVm: MessageViewModel
  first: boolean
  group: MessageGroupModel
}

const MessageGroupMessageContainer = observer(
  function MessageGroupMessageContainer({
    messageVm,
    first,
    group,
  }: MessageGroupMessageContainerProps) {
    return (
      <MessageGroupMessage
        first={first}
        isNote={messageVm.isNote}
        sender={messageSender(group)}
        tagLabel={match(group.tag, {
          None: () => null,
          Admin: () => 'Admin',
          Assistant: () => 'BETA Assistant',
          System: () => 'System',
        })}
        groupTimestamp={group.timestamp}
        dateCreated={messageVm.message.dateCreated}
        onInView={messageVm.markAsRead}
        edit={messageEditProps(messageVm)}
        content={
          <MessageContentContainer
            testId="message-content"
            messageVm={messageVm}
          />
        }
      />
    )
  },
)
